import HtmlParser from "react-html-parser"
import { SVOD_BLOCK_TEXT, metadata } from "lacinetek-common/src/metadata"

import { useTranslation } from "lib/i18n/translation"
import { isSubscriptionOffer } from "tools/subscription"

import SkeletonLink from "../common/skeleton-link"

import OffersSingleIcon from "static/assets/icons/offers-single.svg"
import OffersSelectionIcon from "static/assets/icons/offers-selection.svg"

export const OfferComponent = ({ offer }) => {
	const { c } = useTranslation("common")

	const target = isSubscriptionOffer(offer) ? "/ways-to-watch/subscription" : "/ways-to-watch/film-by-film"

	return (
		<div className="item">
			<SkeletonLink href={target} >
				<a href="#" title={c("learn-more-about")} className="item-content">
					<div className="inline">
						<figure className="medium">
							{
								isSubscriptionOffer(offer)
									? <OffersSelectionIcon title={c("month-selection-icon-title")} />
									: <OffersSingleIcon title={c("tickets-icon")} />
							}
						</figure>
						<div className="infos">
							<h3 className="title">{isSubscriptionOffer(offer) ? c("renew-for") : c("header-single")}</h3>
							<div className="price" dangerouslySetInnerHTML={{ __html: offer.description }} />
						</div>
					</div>
					{
						metadata(offer, SVOD_BLOCK_TEXT)
						&& <div className="description">
							{HtmlParser(metadata(offer, SVOD_BLOCK_TEXT))}
						</div>
					}
				</a>
			</SkeletonLink>
		</div>
	)
}
